export default __webpack_public_path__ + "static/media/profile-blue.17109119.svg";